/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const root = (typeof window !== "undefined") ? window : globalThis;

root.initReadabilityDetails = function(details) {
  const el = $(details);
  const content = $(el).data('content');
  $(el).tooltipster({
    contentAsHTML: true,
    content,
    interactive: true,
    interactiveTolerance: 1000,
    trigger: 'click'
  });
  return closeTooltip();
};

root.closeTooltip = el => $(document).on('click', '.close-details', () => $(el).tooltipster('close'));
